import { dbService } from '../DatabaseService';

const DEFAULT_LANGUAGE_INSTRUCTION = `SPRACHE (VERPFLICHTEND):
Antworte ausschließlich auf Deutsch (de-DE).
Alle Freitextfelder müssen auf Deutsch sein, insbesondere:
- summary
- strengths
- weaknesses
- areasForDiscussion
- qualificationExplanation
- scores[].reason
Verwende keine englischen Sätze oder Stichpunkte.`;

const matchJobTitle = (submission, questionnaire) => {
  const title = questionnaire?.title || '';
  if (title.includes('Einzelhandelsfachkraft')) return 'Einzelhandelsfachkraft';
  if (title.includes('Lagerist')) return 'Lagerist';
  if (title.includes('Kassierer')) return 'Kassierer';
  if (title.includes('Verkäufer')) return 'Verkäufer';
  if (title.includes('Filialleiter')) return 'Filialleiter';
  const positionAnswer = submission?.answers?.default_3;
  if (positionAnswer && String(positionAnswer).trim()) return String(positionAnswer).trim();
  return null;
};

export const loadPromptSources = async ({ submission, questionnaire }) => {
  const jobTitle = matchJobTitle(submission, questionnaire) || questionnaire?.title;
  let templateAnalysisPrompt = '';
  let templateScoringPrompt = '';
  let templateQualificationPrompt = '';

  if (jobTitle) {
    try {
      const allTemplates = await dbService.getTemplates();
      const template = allTemplates.find(
        (t) => String(t?.title || '').trim() === String(jobTitle).trim()
      );
      templateAnalysisPrompt = String(template?.analysis_prompt || '').trim();
      templateScoringPrompt = String(template?.scoring_prompt || '').trim();
      templateQualificationPrompt = String(template?.qualification_prompt || '').trim();
    } catch (e) {
      // Template lookup is best-effort; fall back to settings or defaults.
    }
  }

  let settingsSystemPrompt = '';
  let settingsQualificationPrompt = '';
  let settingsEvaluationLanguageInstruction = '';
  if (!templateAnalysisPrompt || !templateQualificationPrompt) {
    try {
      const settings = await dbService.getSettings();
      if (!templateAnalysisPrompt) settingsSystemPrompt = String(settings?.systemPrompt || '').trim();
      if (!templateQualificationPrompt) settingsQualificationPrompt = String(settings?.qualificationPrompt || '').trim();
      settingsEvaluationLanguageInstruction = String(settings?.evaluationLanguageInstruction || '').trim();
    } catch (e) {
      // Settings lookup is best-effort.
    }
  }

  const scoringConfig = questionnaire?.scoring_config || {};
  return {
    analysisBasePrompt: templateAnalysisPrompt || settingsSystemPrompt || 'Bewerte die Bewerbung fair und objektiv.',
    scoringPrompt: String(scoringConfig.scoringPrompt || '').trim() || templateScoringPrompt,
    qualificationPrompt: templateQualificationPrompt || settingsQualificationPrompt || '',
    languageInstruction: settingsEvaluationLanguageInstruction || DEFAULT_LANGUAGE_INSTRUCTION
  };
};
